import styled from '@emotion/styled';
import { Button, SpaceDivider, Text } from '@innovationdepartment/proxima-ui';
import LockOutlinedIcon from '@mui/icons-material/LockOutlined';

type LockConfirmationViewProps = {
  onConfirm: () => void;
  onBack: () => void;
  brandName: string;
};

const ButtonGroup = styled.div`
  display: inline-flex;
  justify-content: end;
  width: 100%;
  button:first-of-type {
    margin-right: 1rem;
  }
`;

const Container = styled.div`
  padding: 24px;
`;

const LockConfirmationView = ({ onConfirm, onBack, brandName }: LockConfirmationViewProps) => (
  <>
    <Container>
      <SpaceDivider y={2} />
      <Text>
        Are you sure you want to LOCK access for brand{' '}
        <Text color="neutral100" variant="body1Semibold">
          {brandName}
        </Text>
        ? Doing so will NOT allow the brand to create new audiences.
      </Text>
    </Container>
    <SpaceDivider y={4} />
    <ButtonGroup>
      <Button size="small" variant="outlined" label="Back" onClick={onBack} />
      <Button
        size="small"
        color="error"
        label="Lock access"
        startIcon={<LockOutlinedIcon />}
        onClick={onConfirm}
      />
    </ButtonGroup>
  </>
);

export default LockConfirmationView;
